import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ModalShell, ModalHead, ModalFoot } from './MergeModal';
import { addExternalOrder } from '../api/adminExternalOrders';
import { ApiError } from '../api/client';

type Props = {
  onAdded: () => void;
};

export function AddTicketModal({ onAdded }: Props) {
  const navigate = useNavigate();
  const [number, setNumber] = useState('');
  const [firstName, setFirstName] = useState('');
  const [ticketCount, setTicketCount] = useState('1');
  const [submitting, setSubmitting] = useState(false);
  const [errNumber, setErrNumber] = useState<string | null>(null);
  const [errFirstName, setErrFirstName] = useState<string | null>(null);
  const [errTicketCount, setErrTicketCount] = useState<string | null>(null);

  const close = () => navigate('/admin/bilety');

  const submit = async () => {
    setErrNumber(null);
    setErrFirstName(null);
    setErrTicketCount(null);
    const trimmedNumber = number.trim();
    const trimmedFirstName = firstName.trim();
    const count = Number(ticketCount.trim());
    let bad = false;
    if (!trimmedNumber) {
      setErrNumber('Wymagane.');
      bad = true;
    }
    if (!trimmedFirstName) {
      setErrFirstName('Wymagane.');
      bad = true;
    }
    if (!Number.isInteger(count) || count < 1) {
      setErrTicketCount('Liczba całkowita większa od zera.');
      bad = true;
    }
    if (bad) return;

    setSubmitting(true);
    try {
      await addExternalOrder({
        externalId: trimmedNumber.toUpperCase(),
        firstName: trimmedFirstName,
        ticketCount: count,
      });
      onAdded();
      close();
    } catch (err) {
      if (err instanceof ApiError && err.status === 409) {
        setErrNumber('Zamówienie o tym numerze już istnieje.');
      } else if (err instanceof ApiError && err.status === 400) {
        setErrNumber('Niepoprawne dane. Sprawdź pola.');
      } else {
        setErrNumber('Nie udało się dodać zamówienia. Spróbuj ponownie.');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <ModalShell onClose={close} width={520}>
      <ModalHead title="Dodaj zamówienie" subtitle="OPERACJA · RĘCZNIE" onClose={close} />
      <div style={{ padding: 22, display: 'flex', flexDirection: 'column', gap: 14 }}>
        <Field label="Numer zamówienia *" error={errNumber}>
          <input
            className="input-a mono"
            style={{ width: '100%' }}
            placeholder="ORD-2026-…"
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            autoFocus
          />
        </Field>
        <Field label="Imię *" error={errFirstName}>
          <input
            className="input-a"
            style={{ width: '100%' }}
            value={firstName}
            onChange={(e) => setFirstName(e.target.value)}
          />
        </Field>
        <Field label="Liczba biletów *" error={errTicketCount}>
          <input
            className="input-a mono"
            type="number"
            min={1}
            style={{ width: 120 }}
            value={ticketCount}
            onChange={(e) => setTicketCount(e.target.value)}
          />
        </Field>
      </div>
      <ModalFoot>
        <button className="btn-a" onClick={close} disabled={submitting}>
          Anuluj
        </button>
        <button className="btn-a primary" onClick={submit} disabled={submitting}>
          {submitting ? 'Dodawanie…' : '+ Dodaj zamówienie'}
        </button>
      </ModalFoot>
    </ModalShell>
  );
}

function Field({
  label,
  error,
  children,
}: {
  label: string;
  error: string | null;
  children: import('react').ReactNode;
}) {
  return (
    <div className="field">
      <label
        style={{ color: 'var(--admin-ink)', fontSize: 11, fontFamily: 'var(--display)', display: 'block', marginBottom: 4 }}
      >
        {label}
      </label>
      {children}
      {error && (
        <div style={{ marginTop: 4, color: 'var(--orange-deep)', fontSize: 11 }}>
          {error}
        </div>
      )}
    </div>
  );
}
